export enum IconName {
  CART_NAV = 'Cart_nav',
  CHECKMARK_OLD = 'Checkmark_old',
  CLOSE = 'Close',
  CLOSE_BORDER = 'Close_border',
  CLUB = 'Club',
  MENU = 'Menu',
  SEARCH = 'Search',
  USER_MENU = 'User_menu',
  WISHLIST = 'Wishlist',
}
